import React, { FC } from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import IKImage from '../../IKImage/IKImage';
import useStyles from './styles';

interface FullScreenBackgroundWrapProps {
  children: React.ReactNode;
  logoUrl?: string | null;
  backgroundUrl?: string;
  wrapperClass?: string;
  logoClass?: string;
  contentClass?: string;
  'data-testid'?: string;
}

const FullScreenBackgroundWrap: FC<FullScreenBackgroundWrapProps> = ({
  logoUrl,
  backgroundUrl = '/subscriptionBg.png',
  wrapperClass = '',
  logoClass = '',
  contentClass = '',
  children,
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={cx(wrapperClass)} data-testid={rest['data-testid']}>
      <Link to="/home" className={cx(classes.logo, logoClass)}>
        {logoUrl && <IKImage path={logoUrl || ''} draggable={false} alt={'logo'} />}
      </Link>
      <Box className={classes.container}>
        <Box className={classes.imgWrapper}>
          <IKImage
            className={classes.img}
            path={backgroundUrl}
            alt={t('page.subscription.subscribe')}
          />
        </Box>
        <Box className={cx(classes.contentWrap, contentClass)}>{children}</Box>
      </Box>
    </Box>
  );
};

export default FullScreenBackgroundWrap;
